import React, { useRef, useState } from 'react';
import ColorPicker from './ColorPicker';
import '../assets/css/SwipeableList.css';
import '../assets/css/checkbox.css';

const SwipeableListItem = ({ children, index, entry, arr, rightSideActions, setSortedList, saveSearckLookupEntries}) => {
	const swipeRef = useRef(null);
	const [startX, setStartX] = useState(0);
	const [isSwiping, setIsSwiping] = useState(false);
	const {moveToTop, moveUp, moveDown, moveDown10, moveToBottom} = rightSideActions;

	const handleTouchStart = (e) => {
		setStartX(e.touches[0].clientX);
		setIsSwiping(true);
		if (swipeRef.current) swipeRef.current.style.transition = 'none';
	};

	const handleTouchMove = (e) => {
		if (!isSwiping) return;
		const currentX = e.touches[0].clientX;
		const diffX = currentX - startX;
		if (Math.abs(diffX) > 10 && swipeRef.current) {
			swipeRef.current.style.transform = `translateX(${diffX}px)`;
		}
	};

	const handleTouchEnd = () => {
		if (!isSwiping) return;
		setIsSwiping(false);

		const swipeEl = swipeRef.current;
		if (!swipeEl) return;

		const transform = swipeEl.style.transform;
		const diffX = transform ? parseInt(transform.replace('translateX(', '').replace('px)', '')) : 0;

		swipeEl.style.transition = 'transform 0.3s ease';
		if (diffX > 50) {
			// Adjust this translateX line if you add buttons on the left panel
			// console.log("swiping right translating 400px here");
			swipeEl.style.transform = 'translateX(400px)';
		} else if (diffX < -50) {
			// Adjust this translateX line if you add buttons on the right panel
			// console.log("swiping left translating -420px here");
			swipeEl.style.transform = 'translateX(-420px)';
		} else {
			resetPosition();
		}
	};

	const resetPosition = () => {
		const swipeEl = swipeRef.current;
		if (swipeEl) {
			swipeEl.style.transition = 'transform 0.3s ease';
			swipeEl.style.transform = 'translateX(0)';
		}
	};

	const handleItemClick = (e) => {
		// console.log('Restore triggered by whitespace click');
	};

	const handleCheckboxChange = (e, type, entry, index, arr) => {
		e.stopPropagation();
		if (type === 'NEW') {
			arr[index].new = arr[index].new === "1" ? "0" : "1";
		}
		else {
			arr[index].enabled = arr[index].enabled === "1" ? "0" : "1";
		}

		// console.log(type, arr[index].KEYWORD_SEARCH, arr[index].enabled, arr[index].new);
		
		// console.log("DEBUG: called the handleCheckboxChange function");
	};

	return (
		<li key={index} id={index} className="list-item" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onClick={handleItemClick}>
			<div ref={swipeRef} className="swipe-wrapper">
				<div className="left-content">
					<div id={index} className="color-picker" draggable="false">
						<ColorPicker color={entry.backgroundColor} handleColorChange={(newColor) => {
							// console.log("DEBUG:  SwipeableListItem - newColor = ", newColor, " entry = ", entry);
							// console.log(arr[index], entry);
							arr[index].backgroundColor = newColor;
							setSortedList([...arr]);
							// console.log("FROM", JSON.stringify(entry), "TO", JSON.stringify(arr[index]));
							saveSearckLookupEntries(entry, arr[index]);
						}} />
					</div>
					<div id={index} className="color-picker" draggable="false">
						<ColorPicker color={entry.foregroundColor} handleColorChange={(newColor) => {
							// console.log("DEBUG:  SwipeableListItem - newColor = ", newColor, " entry = ", entry);
							// console.log(arr[index], entry);
							arr[index].foregroundColor = newColor;
							setSortedList([...arr]);
							// console.log("FROM", JSON.stringify(entry), "TO", JSON.stringify(arr[index]));
							saveSearckLookupEntries(entry, arr[index]);
						}} />
					</div>
					{/* {(() => {
						console.log("arr[index].new", arr[index].new, typeof arr[index].new);
					})()} */}
					<label className="checkbox-container">
						<input
							className="sr-only"
							type="checkbox"
							checked={arr[index].new === "1" ? true : false}
							onChange={(e) => {
								handleCheckboxChange(e, 'NEW', entry, index, arr);
								setSortedList([...arr]);
								// console.log("FROM", JSON.stringify(entry), "TO", JSON.stringify(arr[index]));
								saveSearckLookupEntries(entry, arr[index]);
							}}
						/>
						<div className="slider"></div>
						<span className="label">NEW</span>
					</label>
					<label className="checkbox-container">
						<input
							className="sr-only"
							type="checkbox"
							checked={arr[index].enabled === "1" ? true : false}
							onChange={(e) => {
								handleCheckboxChange(e, 'ENA', entry, index, arr);
								setSortedList([...arr]);
								// console.log("FROM", JSON.stringify(entry), "TO", JSON.stringify(arr[index]));
								saveSearckLookupEntries(entry, arr[index]);
							}}
						/>
						<div className="slider"></div>
						<span className="label">ENA</span>
					</label>
					<button
						className="retract-button"
						onClick={resetPosition}
						aria-label="Restore"
					>⤺</button>
				</div>

				<span className="item-content">{children}</span>

				<div className="right-content">
					<button
						className="retract-button"
						onClick={resetPosition}
						aria-label="Restore"
					>⤺</button>
					<button className="my-button" style={{background: "#0077FF", color: "#fff"}} onClick={(e) => {
						e.stopPropagation();
						// console.log(`Button clicked with id ${index}`);
						resetPosition();
						moveToTop(index,entry);
					}}>Move to Top</button>
					<button className="my-button" style={{background: "#33B5E5", color: "#fff"}} onClick={(e) => {
						e.stopPropagation();
						// console.log(`Button clicked with id ${index}`);
						resetPosition();
						moveUp(index,entry);
					}}>Move Up</button>
					<button className="my-button" style={{background: "#FFBB33", color: "#000"}} onClick={(e) => {
						e.stopPropagation();
						// console.log(`Button clicked with id ${index}`);
						resetPosition();
						moveDown(index,entry);
					}}>Move Down</button>
					<button className="my-button" style={{background: "#FF8800", color: "#000"}} onClick={(e) => {
						e.stopPropagation();
						// console.log(`Button clicked with id ${index}`);
						resetPosition();
						moveDown10(index,entry);
					}}>Move Down 10</button>
					<button className="my-button" style={{background: "#CC0000", color: "#fff"}} onClick={(e) => {
						e.stopPropagation();
						// console.log(`Button clicked with id ${index}`);
						resetPosition();
						moveToBottom(index,entry);
					}}>Move to Bottom</button>
				</div>
			</div>
		</li>
	);
};

export default SwipeableListItem;
